import React from "react";
import { FileText, ExternalLink, X } from "lucide-react";

interface GuidelineDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const GUIDELINE_URL = "https://indxx.gumlet.io/uat/media/20250308T075721119Z-613547-pdf.pdf";

const GuidelineDrawer: React.FC<GuidelineDrawerProps> = ({ isOpen, onClose }) => {
  return (
    <div
      className={`fixed inset-y-0 right-0 z-[1045] w-520 bg-white shadow-lg transform transition-transform duration-300 ease-in-out ${
        isOpen ? "translate-x-0" : "translate-x-full"
      }`}
      style={{
        width: '640px',
        maxWidth: '100vw'
      }}
    >
      <div className="flex items-center justify-between p-4 border-b">
        <div className="flex justify-between items-center w-full">
          <div className="flex items-center">
            <h5 className="text-lg font-medium">Guidelines</h5>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              className="text-gray-400 hover:text-gray-500"
              onClick={() => window.open(GUIDELINE_URL, '_blank')}
            >
              <ExternalLink className="w-5 h-5" />
            </button>
            <button
              type="button"
              className="text-gray-400 hover:text-gray-500"
              onClick={onClose}
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
      <div className="h-full p-4">
        <iframe
          src={GUIDELINE_URL}
          className="w-full h-[calc(100vh-100px)]"
          title="Guidelines PDF"
        />
      </div>
    </div>
  );
};

export default GuidelineDrawer;
